"use strict";
// TODO: 功能不完善待补充，具体参考 `portal-base` 的 `common/loading/Loading`
// TODO: 考虑外层在 loading 时里层 loading 的展示形式
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
function Loading(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, children = _a.children, _c = _a.childrenVisibility, childrenVisibility = _c === void 0 ? 'visible' : _c, classNameFromProps = _a.className, style = _a.style;
    var prefix = ConfigProvider_1.usePrefix('loading');
    var animationPrefix = utils_1.concat(prefix, 'animation');
    var animationView = (react_1.default.createElement("div", { className: animationPrefix },
        react_1.default.createElement("div", { className: utils_1.concat(animationPrefix, 'dots') },
            react_1.default.createElement("div", { className: utils_1.concat(animationPrefix, 'dot') }),
            react_1.default.createElement("div", { className: utils_1.concat(animationPrefix, 'dot') }),
            react_1.default.createElement("div", { className: utils_1.concat(animationPrefix, 'dot') }))));
    var className = classnames_1.default(prefix, utils_1.concat(prefix, 'mode', childrenVisibility), loading && utils_1.concat(prefix, 'loading'), classNameFromProps);
    var contentClassName = utils_1.concat(prefix, 'content');
    // TODO: 考虑用 `ref` 而不是强行包裹一个容器的方案
    return (react_1.default.createElement("div", { className: className, style: style },
        react_1.default.createElement("div", { className: contentClassName }, children),
        animationView));
}
exports.Loading = Loading;
//# sourceMappingURL=index.js.map